import { regionDefaults } from '../../util/regions';
import {
  START_GET_SEARCH_REGION_DATA,
  END_GET_SEARCH_REGION_DATA,
  SET_SEARCH_REGION_DATA
} from '../actions/regionData';

const regionData = (state = {
    isFetching: false,
    timeStamp: null,
    params: null,
    ...regionDefaults
  }, action) => {
  switch (action.type) {
    case START_GET_SEARCH_REGION_DATA:
      return Object.assign({}, state, {
        isFetching: true
      });
    case END_GET_SEARCH_REGION_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        params: action.params,
        timeStamp: new Date().getTime(),
        learnMoreAboutLinkText: action.response.data.LearnMoreAboutLinkText,
        learnMoreAboutLinkUrl: action.response.data.LearnMoreAboutLinkUrl,
        initLat: action.response.data.InitLat,
        initLng: action.response.data.InitLng,
        initState: action.response.data.InitState,
        initZoom: action.response.data.InitZoom,
        initMobileZoom: action.response.data.InitMobileZoom,
        guestCommunityIds: action.response.data.GuestCommunityIds,
        stateName: action.response.data.StateName,
        metroName: action.response.data.MetroName,
        cityName: action.response.data.CityName,
        regionType: action.response.data.RegionType,
        regionId: action.params.contentId,
        stateMetros: action.response.data.Metros,
        cities: action.response.data.Cities
      });
    case SET_SEARCH_REGION_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        params: action.data.params,
        timeStamp: new Date().getTime(),
        learnMoreAboutLinkText: action.data.learnMoreAboutLinkText,
        learnMoreAboutLinkUrl: action.data.learnMoreAboutLinkUrl,
        initLat: action.data.initLat,
        initLng: action.data.initLng,
        initState: action.data.initState,
        initZoom: action.data.initZoom,
        initMobileZoom: action.data.initMobileZoom,
        guestCommunityIds: action.data.guestCommunityIds,
        stateName: action.data.stateName,
        metroName: action.data.metroName,
        cityName: action.data.cityName,
        regionType: action.data.RegionType,
        regionId: action.data.regionId,
        stateMetros: action.data.stateMetros,
        cities: action.data.Cities
      });
    default:
      return state;
  }
};

export default regionData;